<template lang="html">
  <div text-center d-flex align-center>

    <v-layout wrap justify-space-between v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true || usuarioPROEX === true">
      <v-flex xs12>
        <div class="instrucao">
          <v-card outlined>
            <v-card-text class="black--text font-weight-bold">
              Todas as ações de extensão devem ter como membros da equipe de trabalho estudantes de graduação e/ou pós-graduação. Caso seja necessário, o coordenador poderá cadastrá-los após a aprovação da ação.
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
    </v-layout>

    <v-layout row justify-right>
      <v-flex xs6>
        <v-checkbox v-model="mostrarInativos" label="Mostrar integrantes inativos"></v-checkbox>
      </v-flex>
    </v-layout>
    <v-data-table
    :headers="headers"
    :items="listaIntegrantes"
    :search="search"
    :custom-filter="filtroInativos"
    :no-data-text="'Este projeto não possui integrantes.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.nome="props">
        <div v-if="verificaSeEdicaoIntegrantesNaoPodeSerRealizada() === false && (administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true || usuarioPROEX === true)">
          <router-link v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true" :class="props.item.situacao === 'A' ? 'primary--text' : 'grey--text text--darken-2'"
          :to="{ name: 'EditarIntegrante', params: { idProjeto: idProjeto, idParticipante: props.item.idParticipante }}">
            {{ props.item.nome }}
          </router-link>
          <router-link v-else :class="props.item.situacao === 'A' ? 'primary--text' : 'grey--text text--darken-2'"
          :to="{ name: 'VisualizarIntegrante', params: { idProjeto: idProjeto, idParticipante: props.item.idParticipante }}">
            {{ props.item.nome }}
          </router-link>
        </div>
        <div v-else>
          {{ props.item.nome }}
        </div>
      </template>
      <template v-slot:item.assessor="props">{{formatAssessor.format(props.item.assessor,props.item.funcao.item)}}</template>
      <template v-slot:item.dataInicial="props">{{dates.format(props.item.dataInicial)}}</template>
      <template v-slot:item.dataFinal="props">{{dates.format(props.item.dataFinal)}}</template>
      <template v-slot:item.opcoes="props">
        <div v-if="verificaSeEdicaoIntegrantesNaoPodeSerRealizada() === false">

          <!--<c-tooltip-btn
          icon="assignment"
          color="primary"
          :disabled="false"
          tooltip="Frequência do bolsista"
          disabled-tooltip='Apenas bolsistas podem ter frequência'
          @click="toFrequenciaIntegrante(props.item.idParticipante)"
          ></c-tooltip-btn>-->

          <c-tooltip-btn
          v-if="usuarioPROEX === true || administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true"
          icon="history"
          color="primary"
          tooltip="Histórico do integrante"
          @click="toOcorrenciasIntegrante(props.item.idParticipante)"
          ></c-tooltip-btn>

          <c-tooltip-btn 
          v-if="(administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true) && (props.item.funcao != null && props.item.funcao.item === 1)"
          icon="autorenew"
          color="primary"
          tooltip="Trocar coordenador"
          :disabled="administrador === false"
          disabled-tooltip='Somente o administrador pode alterar o coordenador'
          @click="toTrocarCoordenacao(props.item.idParticipante)"
          ></c-tooltip-btn>

          <c-tooltip-btn 
          v-if="(administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true) && (props.item.funcao.item !== 1 && props.item.situacao === 'A')"
          icon="transfer_within_a_station"
          color="primary"
          tooltip="Finalizar participação"
          @click="toEncerrarParticipacao(props.item.idParticipante)"
          ></c-tooltip-btn>

          <c-tooltip-btn 
          v-if="(administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true) && (props.item.funcao.item !== 1 && props.item.situacao !== 'A')"
          icon="undo"
          color="primary"
          tooltip="Reativar participação"
          @click="toReativarParticipacao(props.item.idParticipante)"
          ></c-tooltip-btn>

          <c-tooltip-btn
          v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1) || projeto.assessor === true"
          icon="delete"
          color="primary"
          :disabled="props.item.funcao != null && props.item.funcao.item === 1"
          tooltip="Excluir integrante"
          disabled-tooltip='O coordenador não pode ser excluído'
          @click="excluirIntegrante(props.item.idParticipante)"
          ></c-tooltip-btn>
        </div>
      </template>
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaIntegrantes.length }} integrantes
      </template>
    </v-data-table>

    <br><br>

    <c-card-footer
      :projeto="this.projeto"
      :extensao="this.extensao"
      :proxima="this.controlaBotaoAvancar()"
      editar="NovoIntegrante"
      nome_editar="Novo integrante"
      :habilitaBotaoGerarPDFAcao=true
      :habilitaBotaoFinalizarAcao="this.botaoFinalizarAcao"
    >
    </c-card-footer>
  </div>
</template>

<script>
import CardFooter from '@/components/c-card-footer'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import TootipButton from '@/components/c-tooltip-btn'
import dates from '@/utils/dates'
import formatAssessor from '@/utils/assessor'
import projetos from '@/utils/projetos'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto', 'extensao'],
  data: () => ({
    mostrarInativos: false,
    botaoFinalizarAcao: true,
    botaoAvancar: true,
    listaIntegrantes: [],
    dates: dates,
    formatAssessor: formatAssessor,
    search: 'ativos',
    sortBy: null,
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Nome', align: 'left', width: '20%', value: 'nome' },
      { text: 'Função', align: 'left', width: '12.5%', value: 'funcao.descricao' },
      { text: 'Assessor', align: 'left', width: '10%', value: 'assessor' },
      { text: 'Vínculo', align: 'left', width: '15%', value: 'vinculo' },
      { text: 'CH semanal', align: 'left', width: '10%', value: 'cargaHoraria' },
      { text: 'Data inicial', align: 'left', width: '10%', value: 'dataInicial' },
      { text: 'Data final', align: 'left', width: '10%', value: 'dataFinal' },
      { text: 'Opções', align: 'left', width: '12.5%', value: 'opcoes' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    // Verifica se a ação de extensão está na situação "Ativo".
    situacaoAtivo: function () {
      if (this.projeto.situacao.item === 18) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão está na situação "Aguardando relatório".
    situacaoAguardandoRelatorio: function () {
      if (this.projeto.situacao.item === 20) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é o coordenador da ação de extensão.
    usuarioCoordenador: function () {
      if ((this.projeto.funcao != null && this.projeto.funcao.item === 1)) {
        return true
      } else {
        return false
      }
    },
    // Verifica se o usuário logado é assessor da ação de extensão.
    usuarioAssessor: function () {
      if (this.projeto.assessor === true) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a ação de extensão possui alunos de graduação ou pós-graduação cadastrados.
    acaoExtensaoNaoPossuiAlunosCadastrados: function () {
      if (this.projeto.possuiAlunos === false) {
        return true
      } else {
        return false
      }
    },
    // Verifica se a edição dos integrantes não pode ser realizada.
    verificaSeEdicaoIntegrantesNaoPodeSerRealizada: function () {
      if (this.situacaoAtivo() || this.situacaoAguardandoRelatorio()) {
        if (this.usuarioCoordenador() || this.usuarioAssessor()) {
          if (this.acaoExtensaoNaoPossuiAlunosCadastrados()) {
            this.botaoFinalizarAcao = false
            this.botaoAvancar = false
            return true
          }
        }
      }
      return false
    },
    controlaBotaoAvancar: function () {
      if (this.botaoAvancar === true) {
        return 'AtividadesProjeto'
      } else {
        return null
      }
    },
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    filtroInativos (value, search, item) {
      return this.mostrarInativos || item.situacao === 'A'
    },
    toFrequenciaIntegrante: function (idParticipante) {
      this.$router.push({ name: 'FrequenciaIntegrante', params: {idProjeto: this.projeto.idProjeto, idParticipante: idParticipante} })
    },
    toOcorrenciasIntegrante: function (idParticipante) {
      this.$router.push({ name: 'OcorrenciasIntegrante', params: {idProjeto: this.projeto.idProjeto, idParticipante: idParticipante} })
    },
    toEncerrarParticipacao: function (idParticipante) {
      this.$router.push({ name: 'EncerrarParticipacao', params: {idProjeto: this.projeto.idProjeto, idParticipante: idParticipante} })
    },
    toReativarParticipacao: function (idParticipante) {
      this.$router.push({ name: 'ReativarParticipacao', params: {idProjeto: this.projeto.idProjeto, idParticipante: idParticipante} })
    },
    toTrocarCoordenacao: function (idParticipante) {
      this.$router.push({ name: 'TrocarCoordenador', params: {idProjeto: this.projeto.idProjeto, idParticipante: idParticipante} })
    },
    carregaIntegrantes: function (idProjeto) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' })
      projetos.getIntegrantesDoProjeto(idProjeto)
      .then(response => {
        var listaIntegrantesAux = []
        listaIntegrantesAux = response.data.slice()
        listaIntegrantesAux = listaIntegrantesAux.sort(
          function (a, b) {
            if (a.situacao === 'A' && b.situacao !== 'A') {
              return -1
            } if (a.situacao !== 'A' && b.situacao === 'A') {
              return 1
            }
            return 0
          }
        )
        this.listaIntegrantes = listaIntegrantesAux.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrantes.' })
      })
    },
    excluirIntegrante: function (idIntegrante) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo integrante.' })
      projetos.deleteIntegrante(this.idProjeto, idIntegrante)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        // this.carregaIntegrantes(this.idProjeto)
        window.location.reload()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo integrante.' })
      })
    }
  },
  mounted () {
    this.carregaIntegrantes(this.idProjeto)
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-card-footer': CardFooter,
    'c-tooltip-btn': TootipButton
  }
}
</script>

<style lang="css" slot-scoped>

.instrucao {
    text-align: center;
    margin-bottom: 2em;
  }

</style>



// WEBPACK FOOTER //
// projeto-integrantes-tabela.vue?61adb162